<template>
  <div class="course-detail">
    <div class="course-header">
      <div class="back-button">
        <el-button icon="el-icon-arrow-left" @click="goBack">返回</el-button>
      </div>
      <div class="course-info">
        <h1>{{ course.name }}</h1>
        <div class="meta-info">
          <span><i class="el-icon-user"></i> {{ course.teacherName }}</span>
          <span><i class="el-icon-time"></i> {{ course.duration }}</span>
          <span><i class="el-icon-notebook-2"></i> {{ course.lessonCount }}课时</span>
        </div>
      </div>
    </div>

    <div class="course-content">
      <el-row :gutter="20">
        <!-- 左侧内容区域 -->
        <el-col :span="16">
          <div class="main-content">
            <!-- 视频播放器 -->
            <div class="video-player">
              <img :src="course.coverImage" alt="课程封面" v-if="!isPlaying">
              <div class="play-button" @click="startPlaying" v-if="!isPlaying">
                <i class="el-icon-video-play"></i>
              </div>
              <!-- 这里可以集成实际的视频播放器组件 -->
            </div>

            <!-- 课程标签页 -->
            <div class="course-tabs">
              <el-tabs v-model="activeTab">
                <el-tab-pane label="课程介绍" name="intro">
                  <div class="course-description">
                    <h3>课程简介</h3>
                    <p>{{ course.description }}</p>
                    
                    <h3>课程目标</h3>
                    <ul>
                      <li v-for="(goal, index) in course.goals" :key="index">
                        {{ goal }}
                      </li>
                    </ul>
                  </div>
                </el-tab-pane>
                
                <el-tab-pane label="课程目录" name="catalog">
                  <div class="course-catalog">
                    <el-collapse v-model="activeChapters">
                      <el-collapse-item v-for="chapter in course.chapters" 
                        :key="chapter.id" 
                        :title="chapter.title"
                        :name="chapter.id"
                      >
                        <div v-for="lesson in chapter.lessons" 
                          :key="lesson.id" 
                          class="lesson-item"
                          :class="{ 'completed': lesson.completed }"
                        >
                          <span class="lesson-title">
                            <i class="el-icon-video-camera"></i>
                            {{ lesson.title }}
                          </span>
                          <span class="lesson-duration">{{ lesson.duration }}</span>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </el-tab-pane>

                <el-tab-pane label="学习笔记" name="notes">
                  <div class="course-notes">
                    <!-- 添加笔记功能 -->
                    <el-input
                      type="textarea"
                      v-model="newNote"
                      placeholder="写下你的学习笔记..."
                      :rows="4"
                    ></el-input>
                    <el-button type="primary" @click="saveNote" style="margin-top: 10px;">
                      保存笔记
                    </el-button>

                    <!-- 笔记列表 -->
                    <div class="notes-list">
                      <div v-for="note in courseNotes" :key="note.id" class="note-item">
                        <p class="note-content">{{ note.content }}</p>
                        <p class="note-time">{{ note.time }}</p>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </el-col>

        <!-- 右侧进度区域 -->
        <el-col :span="8">
          <div class="course-progress">
            <div class="progress-card">
              <h3>学习进度</h3>
              <el-progress type="circle" :percentage="course.progress"></el-progress>
              <div class="progress-stats">
                <div class="stat-item">
                  <div class="stat-value">{{ course.completedLessons }}</div>
                  <div class="stat-label">已完成课时</div>
                </div>
                <div class="stat-item">
                  <div class="stat-value">{{ course.totalLessons }}</div>
                  <div class="stat-label">总课时</div>
                </div>
              </div>
            </div>

            <div class="learning-time">
              <h3>学习时长</h3>
              <div class="time-stats">
                <div class="time-item">
                  <i class="el-icon-time"></i>
                  <span>今日学习：{{ course.todayStudyTime }}</span>
                </div>
                <div class="time-item">
                  <i class="el-icon-date"></i>
                  <span>总学习时长：{{ course.totalStudyTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseDetail',
  data() {
    return {
      isPlaying: false,
      activeTab: 'intro',
      activeChapters: ['1'],
      newNote: '',
      courseNotes: [],
      course: {
        id: '',
        name: '课程加载中...',
        teacherName: '',
        duration: '',
        lessonCount: 0,
        description: '',
        coverImage: '',
        progress: 0,
        completedLessons: 0,
        totalLessons: 0,
        todayStudyTime: '0小时',
        totalStudyTime: '0小时',
        goals: [],
        chapters: []
      }
    }
  },
  
  created() {
    // 获取路由参数中的课程ID
    const courseId = this.$route.params.courseId;
    this.fetchCourseDetail(courseId);
  },
  
  methods: {
    goBack() {
      this.$router.back();
    },
    
    startPlaying() {
      this.isPlaying = true;
      // 实现视频播放逻辑
    },
    
    async fetchCourseDetail(courseId) {
      try {
        // 这里添加实际的API调用
        // const response = await axios.get(`/api/course/${courseId}`);
        // this.course = response.data;
        
        // 模拟数据
        this.course = {
          id: courseId,
          name: '3D建模基础教程',
          teacherName: '张老师',
          duration: '6小时',
          lessonCount: 12,
          description: '本课程将带你深入学习3D建模的基础知识和技巧...',
          coverImage: '/image/jq.jpg',
          progress: 45,
          completedLessons: 5,
          totalLessons: 12,
          todayStudyTime: '2小时',
          totalStudyTime: '8小时',
          goals: [
            '掌握3D建模基础概念',
            '学会使用主流建模工具',
            '完成实战项目练习'
          ],
          chapters: [
            {
              id: '1',
              title: '第一章：基础入门',
              lessons: [
                {
                  id: '1-1',
                  title: '认识3D建模',
                  duration: '30分钟',
                  completed: true
                },
                {
                  id: '1-2',
                  title: '工具介绍',
                  duration: '45分钟',
                  completed: true
                }
              ]
            },
            // 可以添加���多章节...
          ]
        };
      } catch (error) {
        console.error('获取课程详情失败:', error);
        this.$message.error('获取课程详情失败');
      }
    },
    
    saveNote() {
      if (!this.newNote.trim()) {
        this.$message.warning('请输入笔记内容');
        return;
      }
      
      const note = {
        id: Date.now(),
        content: this.newNote,
        time: new Date().toLocaleString()
      };
      
      this.courseNotes.unshift(note);
      this.newNote = '';
      this.$message.success('笔记保存成功');
    }
  }
}
</script>

<style scoped>
.course-detail {
  padding: 20px;
  background-color: #f5f7fa;
}

.course-header {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.back-button {
  margin-bottom: 15px;
}

.course-info h1 {
  margin: 0 0 15px 0;
  font-size: 24px;
  color: #303133;
}

.meta-info span {
  margin-right: 20px;
  color: #606266;
}

.meta-info i {
  margin-right: 5px;
}

.main-content {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.video-player {
  position: relative;
  width: 100%;
  height: 400px;
  background: #000;
  margin-bottom: 20px;
}

.video-player img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 48px;
  color: white;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.course-description {
  padding: 20px 0;
}

.course-description h3 {
  margin: 20px 0 10px 0;
  color: #303133;
}

.course-description ul {
  padding-left: 20px;
}

.course-description li {
  margin: 10px 0;
  color: #606266;
}

.lesson-item {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #EBEEF5;
}

.lesson-item:last-child {
  border-bottom: none;
}

.lesson-item.completed {
  color: #67C23A;
}

.lesson-title i {
  margin-right: 5px;
}

.course-progress {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.progress-card {
  text-align: center;
  margin-bottom: 20px;
}

.progress-stats {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.learning-time {
  margin-top: 20px;
}

.time-stats {
  margin-top: 15px;
}

.time-item {
  margin: 10px 0;
  color: #606266;
}

.time-item i {
  margin-right: 5px;
}

.notes-list {
  margin-top: 20px;
}

.note-item {
  padding: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.note-content {
  margin: 0;
  color: #303133;
}

.note-time {
  margin: 5px 0 0 0;
  font-size: 12px;
  color: #909399;
}
</style> 